import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { FcmNotification } from "./../../../models/common";
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Observable, Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { COUNTRY_CODES } from "../../data/country-codes";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CalenderDialogComponent } from "../calender-dialog/calender-dialog.component";
import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { SlotTimingsComponent } from "src/app/pages/new-v2-pages/new-v2-component/slot-timings/slot-timings.component";
import { redirectLoggedInTo } from "@angular/fire/auth-guard";
import {
  debounceTime,
  filter,
  map,
  startWith,
  switchMap,
} from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CalenderDialogForBookingComponent } from "../calender-dialog-for-booking/calender-dialog-for-booking.component";
import { InvoiceForAdvanceComponent } from "../invoice-for-advance/invoice-for-advance.component";
declare var google: any;

@Component({
  selector: "sm-create-new-booking",
  templateUrl: "./create-new-booking.component.html",
  styleUrls: ["./create-new-booking.component.scss"],
})
export class CreateNewBookingComponent implements OnInit, OnDestroy {
  @ViewChild("mapContainer", { static: false }) mapContainer!: ElementRef;
  houseNumber: any;
  streetName: any;
  landmark: any;
  phone: any;

  isLocationVisible: boolean = false;
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  isEntityIndividual: string = sessionStorage.getItem("isEntityIndividual")!;
  selectedSlab: any = "default";
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  public newbookingData: any = {
    price: 0,
  };
  taxSlabData: any = [];
  repeatArray: any = new Array(0);
  tempObj: any;
  private _apiSubscription: Subscription = new Subscription();
  selectedBookingType: number = 1;
  serviceList: any = [];
  productsList: any = [];
  form: FormGroup;
  discountInfo: any = null;
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private http: HttpClient,
    public _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<CreateNewBookingComponent>,
    private snackBar: MatSnackBar,
    private _ngZone: NgZone
  ) {
    setTimeout(() => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.places
      ) {
        console.error("Google Maps API failed to load in Safari <15.");
        return;
      }

      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.geocoder = new google.maps.Geocoder();
    }, 500);
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
  }
  advancePaymentSettings: any = null;
  ngOnInit(): void {
    console.log(this.parentData);
    if (sessionStorage.getItem(SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS)) {
      this.advancePaymentSettings =
        typeof sessionStorage.getItem(
          SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
        ) == "string"
          ? JSON.parse(
              sessionStorage.getItem(
                SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
              )!
            )
          : sessionStorage.getItem(
              SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
            );
    }
    
    if (this.parentData.data.isForTomorrow == "1") {
      this.changeChip(4);
    }
    if (this.parentData.data.serviceType != "2") {
      let dateobj = this.getOneHourSlot(new Date());
      this.startTime = dateobj.start;
      this.endTime = dateobj.end;
    }

    let data = this.parentData.data;
    this.discountInfo = this.parentData.data.discountInfo;

    if (this.isEntityForeign == "0") {
      this._apiService.getEntityTaxSlabData(data.entityHash);
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash);
    }

    this._apiService.getServicesTypesList(data.eph, "0", "0");
    this._apiService.getEntityProductList(data.entityHash, "1");

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inAddBookings2:", resData);
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resData);

        this.serviceList = [];
        if (resData.result) {
          if (this.parentData.data.serviceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shopStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.parentData.data.serviceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.homeStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.parentData.data.serviceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.for_virtual == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resData);

        this.productsList = [];
        if (resData.result) {
          if (this.parentData.data.serviceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.parentData.data.serviceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.parentData.data.serviceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_FOR_NEW_BOOKING
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          if (this.advancePaymentSettings) {
            if (
              (this.parentData.data.serviceType == 1 &&
                this.advancePaymentSettings.shop_service == 1) ||
              (this.parentData.data.serviceType == 0 &&
                this.advancePaymentSettings.home_service == 1) ||
              (this.parentData.data.serviceType == 2 &&
                this.advancePaymentSettings.virtual_service == 1)
            ) {
              this._modelRef.open(InvoiceForAdvanceComponent, {
                width: "510px",
                data: {
                  title: "Invoice",
                  ref: this._modelRef,
                  showmerge: 0,
                  data: JSON.parse(resData.result).bookingHashId,
                },
              });
            }
          }
          this.activemodal.close({
            selectedBookingType: this.selectedBookingType,
            bookingData: this.tempObj,
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceComponent, {
            width: "510px",
            data: {
              title: "Invoice",
              ref: this._modelRef,
              showmerge: 1,
              data: JSON.parse(resData.result).bookingHashId,
            },
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE
      ) {
        this.autocompleteItems = [];
        if (resData.result) {
          this.autocompleteItems = resData.result;
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
        this.loaderForAutocomplete = false;
      }
    });
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code
  );
  contactselectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
  today = new Date();
  selectedDate: any = null;
  onSelectDate() {
    const dialogRef = this._modelRef.open(CalenderDialogForBookingComponent, {
      width: "350px",
      panelClass: "calender-dialog-container",
      data: {
        selectedDate: this.today,
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.selectedBookingType = 5;
        this.selectedDate = data;
        if (this.parentData.data.serviceType == "2") {
          this.startTime = this.endTime = this.newbookingData.note = null;
        }
        console.log(this.today);

        // this.ngOnInit();
      }
    });
  }

  formChecker() {
    if (this.newbookingData.customerPh) {
      if (
        this.newbookingData.customerPh.length >= 3 &&
        this.newbookingData.customerPh.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  serviceInfo: any = [];
  productInfo: any = [];
  onPost() {
    if (!this.startTime || !this.endTime) {
      this.snackBar.open("Please select a slot to continue.", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.serviceInfo = [];
      this.productInfo = [];
      this.selectedJobs.forEach((element: any) => {
        this.serviceInfo.push({
          serviceTypeHash: element.hash_id,
          serviceName: element.serviceName,
          description: element.description,
          imgUrl: element.imgUrl,
          rate:
            this.parentData.data.serviceType == "0"
              ? element.discountStatus == 1
                ? element.homeDiscountedPrice
                : element.home_rate
              : this.parentData.data.serviceType == "1"
              ? element.discountStatus == 1
                ? element.shopDiscountedPrice
                : element.shop_rate
              : element.discountStatus == 1
              ? element.virtual_discounted_amount
              : element.virtual_rate,
          approxTime: element.approxTime,
          shop_rate: element.shop_rate,
          home_rate: element.home_rate,
          shopStatus: element.shopStatus,
          homeStatus: element.homeStatus,
          discountStatus: element.discountStatus,
          discountType: element.discountType,
          discountAmount: element.discountAmount,
          shopDiscountedPrice: element.shopDiscountedPrice,
          homeDiscountedPrice: element.homeDiscountedPrice,
          qty: element.selectedCount,
          service_sac_code: element.service_sac_code,
          tax_slab_hash: element.tax_slab_hash,
        });
      });

      this.productInfo = this.selectedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.product_desc,
          entity_product_hash: item.hash_id,
          product_img_url: item.thumb_image_url,
          product_price:
            this.parentData.data.serviceType == "0"
              ? item.discount_status == 1
                ? item.home_discounted_price
                : item.home_price * item.selectedCount
              : this.parentData.data.serviceType == "1"
              ? item.discount_status == 1
                ? item.shop_discounted_price
                : item.shop_price * item.selectedCount
              : item.discount_status == 1
              ? item.virtual_discounted_price
              : item.virtual_price * item.selectedCount,
          product_qty: item.selectedCount,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.selectedCount * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.selectedCount) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let applicableDiscount = 0;
      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
              // virtual service
              if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    applicableDiscount = this.discountInfo.maxDiscount;
                  } else {
                    applicableDiscount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
              // virtual service
              if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  applicableDiscount = this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }
      let data = {
        bookingStatusInfo: {
          assignedToHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          bookingType: this.parentData.data.serviceType,
          appointmentHash: "",
          assignedByHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          entityHash: this.parentData.data.entityHash,
          bookingStatus: 5,
          price: this.newbookingData.price,
          startTime: this.startTime,
          endTime: this.endTime,
          note: this.newbookingData.note ?? "",
          newCustomer: 1,
          countryCode: this.selectedCountryCode.dial_code,
          customerPh: this.newbookingData.customerPh
            ? this.newbookingData.customerPh
            : "0000000000",
          customerName: this.newbookingData.customerName
            ? this.newbookingData.customerName
            : "Guest Customer",
          servicesInfo: this.serviceInfo,
          products: this.productInfo,
          custom_items: this.form.get("items")!.value.map((item: any) => {
            return {
              item_name: item.name.item_name ? item.name.item_name : item.name,
              item_desc: item.name.item_desc ?? "",
              item_inventory_hash: item.name.hash_id ?? "",
              item_img_url: item.name.image_thumb_url ?? "",
              item_qty: item.count,
              item_price: +item.price,
              tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
            };
          }),
          bookingDate: this.formatDateString(
            new Date(this.selectedDate ? this.selectedDate : this.today)
          ),
          discount: +applicableDiscount.toFixed(2),
          booking_address: undefined as any,
        },
      };

      if (this.parentData.data.serviceType == 0) {
        data.bookingStatusInfo.booking_address = {
          landmark: this.landmark,
          street_name: this.streetName,
          house_no: this.houseNumber,
          city: this.selectedLocation.city,
          state: this.selectedLocation.state,
          country: this.selectedLocation.country,
          zip: this.selectedLocation.zip,
          lat: this.lat,
          lng: this.lng,
          address_line: this.formattedAddress,
          booking_type: this.parentData.data.serviceType,
          status: 1,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          country_code: this.contactselectedCountryCode.dial_code,
          phone: this.phone,
        };

        Object.keys(data.bookingStatusInfo.booking_address).forEach((key) => {
          if (
            (data.bookingStatusInfo.booking_address as any)[key] === null ||
            (data.bookingStatusInfo.booking_address as any)[key] ===
              undefined ||
            (data.bookingStatusInfo.booking_address as any)[key] === "" ||
            (data.bookingStatusInfo.booking_address as any)[key] === "null"
          ) {
            delete (data.bookingStatusInfo.booking_address as any)[key];
          }
        });
      }

      Object.keys(data.bookingStatusInfo).forEach((key) => {
        if ((data.bookingStatusInfo as any)[key] === null) {
          delete (data.bookingStatusInfo as any)[key];
        }
      });

      data.bookingStatusInfo.servicesInfo.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.bookingStatusInfo.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });

      this.tempObj = data;
      console.log(data);

      this.loader.showLoader = true;
      this._apiService.updateBookingStatusForNewBooking(data);
    }
  }

  allDone() {
    this.serviceInfo = [];

    this.selectedJobs.forEach((element: any) => {
      this.serviceInfo.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        img_url: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        service_cost:
          this.parentData.data.serviceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        bookingType: this.parentData.data.serviceType,
        appointmentHash: "",
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: this.selectedBookingType,
        price: this.newbookingData.price.toString(),
        startTime: this.formatTime(new Date()),
        endTime: this.formatTime(new Date()),
        note: this.newbookingData.note ? this.newbookingData.note : "",
        customerPh: this.newbookingData.customerPh
          ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        completedServices: this.serviceInfo,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatusWithInvoice(data);
  }

  completedServices: any = [];
  partiallyDone() {
    this.selectedJobs.forEach((element: any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        service_cost:
          this.parentData.data.serviceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        bookingType: this.parentData.data.serviceType,
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: 9,
        price: this.newbookingData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.newbookingData.note,
        customerPh: this.newbookingData.customerPh
          ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }
  allDoneAndRelease() {
    this.selectedJobs.forEach((element: any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        service_cost:
          this.parentData.data.serviceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        bookingType: this.parentData.data.serviceType,
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: 4,
        price: this.newbookingData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.newbookingData.note,
        customerPh: this.newbookingData.customerPh
          ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }

  changeChip(value: number) {
    this.selectedDate = null;
    if (this.parentData.data.serviceType == "2") {
      this.startTime = this.endTime = this.newbookingData.note = null;
    }
    this.selectedBookingType = value;
    if (value == 1) {
      this.selectedDate = new Date();
    } else if (value == 4) {
      let tempDate = new Date();
      tempDate.setDate(tempDate.getDate() + 1);
      this.selectedDate = new Date(tempDate);
    }
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }
  decreaseServiceCount(item: any, index: any) {
    if (this.selectedJobs[index].selectedCount == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.parentData.data.serviceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].virtual_rate;
        }
      }

      this.serviceList[index1].toShow = true;
      this.selectedJobs.splice(index, 1);
    } else {
      this.selectedJobs[index].selectedCount--;

      if (this.parentData.data.serviceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.newbookingData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.newbookingData.price -= this.selectedJobs[index].virtual_rate;
        }
      }
    }
  }
  increaseServiceCount(item: any, index: any) {
    this.selectedJobs[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.parentData.data.serviceType == "0") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.newbookingData.price +=
          this.selectedJobs[index].homeDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.newbookingData.price += this.selectedJobs[index].home_rate;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.newbookingData.price +=
          this.selectedJobs[index].shopDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.newbookingData.price += this.selectedJobs[index].shop_rate;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.newbookingData.price +=
          this.selectedJobs[index].virtual_discounted_amount;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.newbookingData.price += this.selectedJobs[index].virtual_rate;
      }
    }
  }
  decreaseProductCount(item: any, index: any) {
    if (this.selectedProducts[index].selectedCount == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.parentData.data.serviceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_price;
        }
      }

      this.productsList[index1].toShow = true;
      this.selectedProducts.splice(index, 1);
    } else {
      this.selectedProducts[index].selectedCount--;

      if (this.parentData.data.serviceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.parentData.data.serviceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.parentData.data.serviceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.newbookingData.price -=
            this.selectedProducts[index].virtual_price;
        }
      }
    }
  }
  increaseProductCount(item: any, index: any) {
    this.selectedProducts[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.parentData.data.serviceType == "0") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.newbookingData.price +=
          this.selectedProducts[index].home_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.newbookingData.price += this.selectedProducts[index].home_price;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.newbookingData.price +=
          this.selectedProducts[index].shop_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.newbookingData.price += this.selectedProducts[index].shop_price;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.newbookingData.price +=
          this.selectedProducts[index].virtual_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.newbookingData.price += this.selectedProducts[index].virtual_price;
      }
    }
  }

  selectedJobs: any = [];
  selectServices(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    this.serviceList[index].selectedCount = 1;
    this.selectedJobs.push(this.serviceList[index]);
    if (this.parentData.data.serviceType == "0") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.newbookingData.price +=
          this.serviceList[index].homeDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.newbookingData.price += this.serviceList[index].home_rate;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.newbookingData.price +=
          this.serviceList[index].shopDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.newbookingData.price += this.serviceList[index].shop_rate;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.newbookingData.price +=
          this.serviceList[index].virtual_discounted_amount;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.newbookingData.price += this.serviceList[index].virtual_rate;
      }
    }
    this.serviceList[index].toShow = false;
  }

  selectedProducts: any = [];
  selectProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    this.productsList[index].selectedCount = 1;
    this.selectedProducts.push(this.productsList[index]);
    if (this.parentData.data.serviceType == "0") {
      if (
        this.productsList[index].discount_status &&
        this.productsList[index].discount_status == 1
      ) {
        this.newbookingData.price +=
          this.productsList[index].home_discounted_price;
      } else if (
        !this.productsList[index].discount_status ||
        this.productsList[index].discount_status == 0
      ) {
        this.newbookingData.price += this.productsList[index].home_price;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (
        this.productsList[index].discount_status &&
        this.productsList[index].discount_status == 1
      ) {
        this.newbookingData.price +=
          this.productsList[index].shop_discounted_price;
      } else if (
        !this.productsList[index].discount_status ||
        this.productsList[index].discount_status == 0
      ) {
        this.newbookingData.price += this.productsList[index].shop_price;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (
        this.productsList[index].discount_status &&
        this.productsList[index].discount_status == 1
      ) {
        this.newbookingData.price +=
          this.productsList[index].virtual_discounted_price;
      } else if (
        !this.productsList[index].discount_status ||
        this.productsList[index].discount_status == 0
      ) {
        this.newbookingData.price += this.productsList[index].virtual_price;
      }
    }
    this.productsList[index].toShow = false;
  }

  removeSelectedJobs(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.selectedJobs.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    if (this.parentData.data.serviceType == "0") {
      if (this.selectedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].homeDiscountedPrice *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].home_rate *
          this.selectedJobs[index1].selectedCount;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.selectedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].shopDiscountedPrice *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].shop_rate *
          this.selectedJobs[index1].selectedCount;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.selectedJobs[index1].discountStatus == 1) {
        this.newbookingData.price -=
          this.selectedJobs[index1].virtual_discounted_amount *
          this.selectedJobs[index1].selectedCount;
      } else if (this.selectedJobs[index1].discountStatus == 0) {
        this.newbookingData.price -=
          this.selectedJobs[index1].virtual_rate *
          this.selectedJobs[index1].selectedCount;
      }
    }

    this.serviceList[index].toShow = true;
    this.selectedJobs.splice(index1, 1);
  }
  removeSelectedProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.selectedProducts.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    if (this.parentData.data.serviceType == "0") {
      if (this.selectedProducts[index1].discount_status == 1) {
        this.newbookingData.price -=
          this.selectedProducts[index1].home_discounted_price *
          this.selectedProducts[index1].selectedCount;
      } else if (this.selectedProducts[index1].discount_status == 0) {
        this.newbookingData.price -=
          this.selectedProducts[index1].home_price *
          this.selectedProducts[index1].selectedCount;
      }
    } else if (this.parentData.data.serviceType == "1") {
      if (this.selectedProducts[index1].discount_status == 1) {
        this.newbookingData.price -=
          this.selectedProducts[index1].shop_discounted_price *
          this.selectedProducts[index1].selectedCount;
      } else if (this.selectedProducts[index1].discount_status == 0) {
        this.newbookingData.price -=
          this.selectedProducts[index1].shop_price *
          this.selectedProducts[index1].selectedCount;
      }
    } else if (this.parentData.data.serviceType == "2") {
      if (this.selectedProducts[index1].discount_status == 1) {
        this.newbookingData.price -=
          this.selectedProducts[index1].virtual_discounted_price *
          this.selectedProducts[index1].selectedCount;
      } else if (this.selectedProducts[index1].discount_status == 0) {
        this.newbookingData.price -=
          this.selectedProducts[index1].virtual_price *
          this.selectedProducts[index1].selectedCount;
      }
    }

    this.productsList[index].toShow = true;
    this.selectedProducts.splice(index1, 1);
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  addOneHourAndFormat(date: Date): string {
    const newDate = new Date(date);
    newDate.setHours(date.getHours() + 1);

    const hours = newDate.getHours().toString().padStart(2, "0");
    const minutes = newDate.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  startTime: any = null;
  endTime: any = null;
  onSelectSlot() {
    this.loader.showLoader = true;
    let dialogref = this._modelRef.open(SlotTimingsComponent, {
      data: {
        isToday: this.selectedBookingType == 1 ? true : false,
        day: this.selectedDate
          ? new Date(this.selectedDate).getDay() + 1
          : new Date(this.today).getDay() + 1,
        entityHash: "jjjj",
        serviceType: this.parentData.data.serviceType,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);
        if (res?.link) {
          this.newbookingData.note = res?.link[0].meeting_details;
        } else {
          this.newbookingData.note = null;
        }
        this.startTime = res.startTime;
        this.endTime = res.endTime;
      }
    });
  }

  getOneHourSlot(date: Date) {
    // Convert to local time string in 24-hour format
    const localTimeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Get hours and minutes
    let [hours, minutes] = localTimeString.split(":").map(Number);

    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;

    // Calculate next hour
    let endHour = (startHour + 1) % 24;

    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour: any) => hour.toString().padStart(2, "0");

    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`,
    };
  }
  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  // addFormField(){
  //   this.repeatArray.length++
  // }

  // removeFormField(index:any){
  //   this.repeatArray.splice(index,1)
  // }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): FormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as FormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // Get the form array of items
  get items(): FormArray {
    return this.form.get("items") as FormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.newbookingData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.newbookingData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  // ------------ CUSTOMER NAME AUTOCOMPLETE ---------------
  firstTimeBelow3: boolean = false;
  loaderForAutocomplete: boolean = false;
  debounceTimer: any; // Declare this at the class level
  autocompleteItems: any = [];

  searchCustomerName(event: any) {
    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }
    const ignoredKeys = [
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Shift",
      "Control",
      "Alt",
      "Meta",
      "Tab",
      "Escape",
    ];

    if (ignoredKeys.includes(event.key)) {
      return;
    }

    clearTimeout(this.debounceTimer); // Clear previous timer

    this.debounceTimer = setTimeout(() => {
      const value = this.newbookingData.customerName ?? "";
      console.log(value);

      if (value.length >= 3) {
        console.log("holfirst");
        this.loaderForAutocomplete = true;
        this.firstTimeBelow3 = true;
        this._apiService.getCustomerListForAutoComplete(
          value,
          this.parentData.data.entityHash
        );
      } else {
        if (this.firstTimeBelow3) {
          console.log("holsecond");
          this.autocompleteItems = [];
          this.firstTimeBelow3 = false;
        }
      }
    }, 300); // Delay in ms
  }

  selectSearchResult(customer: any) {
    this.autocompleteItems = [];
    this.newbookingData.customerName = customer.name;
    this.selectedCountryCode = this.countryList.find(
      (country) => country.dial_code === customer.country_code
    );
    this.newbookingData.customerPh = customer.phone;
  }

  // -------------------- MAP THINGS ---------------------------

  map!: google.maps.Map;
  marker!: google.maps.Marker;
  geocoder!: google.maps.Geocoder;
  lat: any;
  lng: any;
  initializeMap(address?: any, description?: any) {
    let mapOptions: google.maps.MapOptions;

    if (address && address.latitude && address.longitude) {
      this.lat = address.latitude;
      this.lng = address.longitude;
      mapOptions = {
        center: new google.maps.LatLng(address.latitude, address.longitude),
        zoom: 12,
      };
    } else {
      mapOptions = {
        center: new google.maps.LatLng(28.6139298, 77.2088282), // fallback (Delhi for example)
        zoom: 5,
      };
    }

    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);

    // Create marker only if coordinates exist
    if (address && address.latitude && address.longitude) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: mapOptions.center,
      });

      this.geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(
        address.latitude,
        address.longitude
      );
      this.geocodePosition(latLng, description);

      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    }
  }

  // this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
  geocodePosition(latLng: google.maps.LatLng, description?: any) {
    console.log(latLng);
    console.log(description);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            description ? description : results[0].formatted_address
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
          console.log(this.lat, this.lng);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }
  geocodePositionOverwrite(latLng: google.maps.LatLng) {
    console.log(latLng);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            results[0].formatted_address
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }

  // async getCurrentLocation(): Promise<any> {
  //   return new Promise(async (resolve, reject) => {
  //     if ('geolocation' in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         async position => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             resolve({ latitude, longitude});
  //           } catch (error) {
  //             reject('Error getting location info');
  //           }
  //         },
  //         error => reject(error)
  //       );
  //     } else {
  //       reject('Geolocation is not supported by your browser.');
  //     }
  //   });
  // }

  // async getCurrentLocation(): Promise<any> {
  //   try {
  //     const position = await Geolocation.getCurrentPosition();
  //     const coords = position.coords;
  //     console.log(JSON.stringify(position));

  //     return {
  //       latitude: coords.latitude.toString(),
  //       longitude: coords.longitude.toString(),
  //     };
  //   } catch (err) {
  //     console.error("Error fetching location", err);
  //     throw err;
  //   }
  // }
  location: any = "";
  targetaddress: any = "";
  selectedLocation: any = {};
  formattedAddress: any;
  storeLocation(location: any, formatted_address: any, description: any) {
    console.log(location);
    let address: any = {
      latitude: "",
      longitude: "",
      city: "",
      state: "",
      country: "",
      sublocality_level_1: "",
      zip: "",
    };

    location?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === "postal_code") {
        address.zip = data.long_name;
      } else if (type === "locality") {
        address.city = data.long_name;
      } else if (type === "administrative_area_level_1") {
        address.state = data.long_name;
      } else if (type === "country") {
        address.country = data.long_name;
      } else if (data.types.includes("sublocality_level_1")) {
        address.sublocality_level_1 = data.long_name;
      }
    });

    console.log(address);

    // ---------- ASSIGN TO KEYWORD ---------------

    const addressComponents = location || [];
    const priorityMap: any = {
      locality: null,
      administrative_area_level_1: null,
      country: null,
    };

    // Extract values based on priority
    addressComponents.forEach((data: any) => {
      const type = data.types[0];
      if (type in priorityMap && !priorityMap[type]) {
        priorityMap[type] = data.long_name;
      }
    });

    // Assign location based on priority
    this.location =
      priorityMap.locality ||
      priorityMap.administrative_area_level_1 ||
      priorityMap.country;

    address.latitude = this.lat ?? "";
    address.longitude = this.lng ?? "";
    address.formatted_address = description ?? "";

    this.selectedLocation = address;
    console.log(this.selectedLocation);

    this.formattedAddress = description;
    console.log(this.formattedAddress);
  }

  locationInput: string = "";
  googleAutoCompleteItems: any[] = [];
  GoogleAutocomplete: any;

  onInputChange() {
    this.locationSelected = false;
    if (!this.formattedAddress.trim()) {
      this.googleAutoCompleteItems = [];
      return;
    }

    this.GoogleAutocomplete.getPlacePredictions(
      { input: this.formattedAddress },
      (predictions: any, status: any) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          this.googleAutoCompleteItems = predictions;
        }
      }
    );

    console.log(this.googleAutoCompleteItems);
  }

  locationSelected = false;
  selectItem(item: any) {
    this.locationSelected = true; // ✅ user picked from list
    console.log(item);
    this.googleAutoCompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this._ngZone.run(() => {
            // this.profileData.address_line = results[0].formatted_address;

            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.updateMapCoordinates(this.lat, this.lng, item.description);
            this.storeLocation(
              results[0].address_components,
              results[0].formatted_address,
              item.description
            );
          });
        }
      }
    );
  }

  /**
   * Update map center and marker without recreating the google map instance.
   * lat/lng can be numbers or numeric strings.
   * opts: { zoom?: number, animate?: boolean } - animate isn't used (Google Maps JS has no built-in smooth pan),
   * but we keep opts for future extension.
   */
  updateMapCoordinates(
    lat: number | string,
    lng: number | string,
    description?: any
  ) {
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (isNaN(latNum) || isNaN(lngNum)) {
      console.warn("updateMapCoordinates: invalid lat/lng", lat, lng);
      return;
    }

    // ensure map exists
    if (!this.map) {
      // If map hasn't been created yet, call initializeMap with these coords
      this.initializeMap({ latitude: latNum, longitude: lngNum }, description);
      return;
    }

    const latLng = new google.maps.LatLng(latNum, lngNum);
    this.map.setZoom(12);

    // center map
    this.map.setCenter(latLng);

    // create marker if missing
    if (!this.marker) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: latLng,
      });

      // add dragend listener once when marker created
      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    } else {
      // move existing marker
      this.marker.setPosition(latLng);
    }

    // update geocoder results & component state
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    this.geocodePosition(latLng, description);

    // keep internal lat/lng in sync (string with fixed decimals if you prefer)
    this.lat = latNum.toFixed ? latNum.toFixed(6) : latNum;
    this.lng = lngNum.toFixed ? lngNum.toFixed(6) : lngNum;
  }

  // -0-0-000-00-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0-0

  gotoaddressorToggle() {
    if (!this.isLocationVisible) {
      this.phone = this.newbookingData.customerPh;
      this.contactselectedCountryCode = this.countryList.find(
        (country) => country.dial_code === this.selectedCountryCode.dial_code
      );

      if (!this.formattedAddress) {
        setTimeout(() => {
          this.initializeMap(
            {
              latitude: "28.6139298",
              longitude: "77.2088282",
            },
            "New Delhi, Delhi, India"
          );
        }, 1);
      } else {
        setTimeout(() => {
          this.initializeMap(
            {
              latitude: this.lat,
              longitude: this.lng,
            },
            this.formattedAddress
          );
        }, 1);
      }

      // if (
      //   this.userProfileAddress?.address_line &&
      //   this.userProfileAddress?.address_line != '' &&
      //   this.userProfileAddress?.address_line != 'null'
      // ) {
      //   this.formattedAddress = this.userProfileAddress.address_line;
      //   this.selectedLocation.city = this.userProfileAddress.city;
      //   this.selectedLocation.state = this.userProfileAddress.state;
      //   this.selectedLocation.country = this.userProfileAddress.country;
      //   this.selectedLocation.zip = this.userProfileAddress.zip;
      //   this.lat = this.userProfileAddress.lat;
      //   this.lng = this.userProfileAddress.lng;
      //   setTimeout(() => {
      //     this.initializeMap(
      //       {
      //         latitude: this.userProfileAddress.lat,
      //         longitude: this.userProfileAddress.lng,
      //       },
      //       this.userProfileAddress.address_line
      //     );
      //   }, 1);
      // } else {
      //   setTimeout(() => {
      //     this.initializeMap(
      //       {
      //         latitude: '28.6139298',
      //         longitude: '77.2088282',
      //       },
      //       'New Delhi, Delhi, India'
      //     );
      //   }, 1);
      // }
    }
    this.isLocationVisible = !this.isLocationVisible;
  }
}
